/**
 * Get the button style props for the link button
 *
 * @param linkStyle
 *   The link style to get the props for
 *
 * @returns
 *   The button style props
 */
export function getButtonStyleProps(linkStyle: string) {
  let styleProp: any = 'primary';

  if (linkStyle?.includes('primary')) {
    styleProp = 'primary';
  } else if (linkStyle?.includes('secondary')) {
    styleProp = 'secondary';
  } else if (linkStyle?.includes('default')) {
    styleProp = 'default';
  } else {
    return;
  }

  // Same but for raised (boolean prop)
  const raised = !linkStyle?.includes('not-raised');
  const bordered = linkStyle?.includes('bordered');

  return {
    buttonStyle: styleProp,
    raised,
    bordered,
  };
}
